import { render, staticRenderFns } from "./ProductivityChannel.vue?vue&type=template&id=ec9c1412"
import script from "./ProductivityChannel.vue?vue&type=script&lang=js"
export * from "./ProductivityChannel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports